import { Theme } from '@mui/material'

export default (theme: Theme): string => `
.DsFlag-root {
    display: inline-block;
    background-repeat: no-repeat;
    vertical-align: middle;
}

.DsFlag-small {
    width: 16px;
    height: 16px;
    background-size: 301px;
    background-image: url(${theme.assetsBaseUrl}images/flags-16-sprite.png);
}

.DsFlag-large {
    width: 31px;
    height: 25px;
    background-size: 556px 520px;
    background-image: url(${theme.assetsBaseUrl}images/flags-32-sprite.png);
    border-radius: 10%;
}
`
